import Promise from 'promise';
import { axios } from '../_helpers';
import { toastr } from 'react-redux-toastr';
import { SVCMessage } from '../_helpers';

export const CourseHomeService = {
    getAll,
    save,
    update,
    getAllCollection,
    getAllCollectionWhichHasTopic,
    addCollection,
    editCollection,
    getCourseInformation,
    deleteCollectionInfo,
    deleteCollection,
    getCourseInformation,
    saveConfigurationCollection,
    getCourseVideos,
    getCourseDetail,
    updateCourseHome,
    getCourseHome,
    addCollectionBookCodeConfiguration,
    removeCollectionBookCodeConfiguration,
    reOrderCollectionList,
    reOrderTopicsList
};

function getAll() {
    return axios.get('api/coursehome/getAll').then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function save(course) {
    return axios.post('api/coursehome/create', course).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function update(course) {
    return axios.post('api/coursehome/update', course).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function getAllCollection() {
    return new Promise(function (resolve, reject) {
        axios.get('getAllCollection').then((res) => {
            //   let result = res.data;
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function getAllCollectionWhichHasTopic() {
    return new Promise(function (resolve, reject) {
        axios.get('getAllCollectionWhichHasTopic').then((res) => {
            //   let result = res.data;
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};


function addCollection(data) {

    return new Promise(function (resolve, reject) {
        axios.post('addCollection', data).then((res) => {
            if (res.isSuccess) {
                resolve(res);
            } else {
                toastr.error(SVCMessage[res.message]);
                resolve(res.data);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function editCollection(data) {
    return new Promise(function (resolve, reject) {
        axios.post('editCollection', data).then((res) => {
            if (res.isSuccess) {
                resolve(res);
            } else {
                toastr.error(SVCMessage[res.message]);
                resolve(res.data);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function deleteCollectionInfo(data) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteCollectionInfo', data).then((res) => {
            resolve(res)
        }).catch(error => {
            reject(error.message);
        });
    });
};

function deleteCollection(data) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteCollection', data).then((res) => {
            resolve(res)
        }).catch(error => {
            reject(error.message);
        });
    });
};

function getCourseInformation(bookId) {
    return new Promise(function (resolve, reject) {
        axios.get('getCourseInformation?bookId=' + bookId).then((res) => {
            let result = res.data;
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}

function getCourseDetail(bookId) {
    return new Promise(function (resolve, reject) {
        axios.get('getCourseDetail?bookId=' + bookId).then((res) => {
            let result = res.data;
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}

function updateCourseHome(param) {
    return new Promise(function (resolve, reject) {
        axios.post('updateCourseHome', param).then((res) => {
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });
}


function saveConfigurationCollection(data) {
    return new Promise(function (resolve, reject) {
        axios.post('addCollectionToCourse', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            }
            else {
                toastr.error(SVCMessage[res.message]);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function addCollectionBookCodeConfiguration(data) {
    return new Promise(function (resolve, reject) {
        axios.post('addCourseCollection', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            }
            else {
                toastr.error(SVCMessage[res.message]);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function removeCollectionBookCodeConfiguration(data) {
    return new Promise(function (resolve, reject) {
        axios.post('removeCourseCollection', data).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]); //
                resolve(res.data);
            }
            else {
                toastr.error(SVCMessage[res.message]);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
};

function getCourseVideos(bookId) {
    return new Promise(function (resolve, reject) {
        axios.get('getAllCourseVideos?bookId=' + bookId).then((res) => {
            let result = res.data;
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}


function getCourseHome() {
    let url = JSON.parse(localStorage.getItem('user')).custom_BookCode;
    return new Promise(function (resolve, reject) {
        axios.get('getCourseHome?bookCode=' + encodeURIComponent(url)).then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    });
}

function reOrderCollectionList(collection) {
    return axios.post('reOrderCollectionlist', collection).then((res) => {
        if (res.isSuccess) {
            toastr.success(SVCMessage[res.message]);
        }
        return res.isSuccess;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function reOrderTopicsList(topic) {
    return axios.post('reOrderTopiclist', topic).then((res) => {
        if (res.isSuccess) {
            toastr.success(SVCMessage[res.message]);
        }
        return res.isSuccess;
    }).catch((error) => {
        return Promise.reject(error);
    });
};


// WEBPACK FOOTER //
// ./src/_services/course-home.service.js